const Rope = ({ hasRopeHead }) => {
  return (
    <g id="rope">
      {hasRopeHead && (
        <>
          <path
            id="head"
            d="M39.4706 118.929C37.458 121.811 35.6235 124.071 33.7372 127.326C32.4362 130.075 30.9 132.79 29.8529 135.643C28.6376 138.955 27.8178 142.41 27.2472 145.909C26.4024 151.087 26.3467 156.691 27.749 161.771C29.1511 166.851 32.0273 172.108 36.6802 174.862C40.1463 176.914 44.3327 177.236 47.5678 174.555C54.02 169.207 55.3932 159.604 55.3932 151.768C55.3932 144.003 53.643 136.656 50.6214 129.526C49.152 126.058 46.83 121.91 44.6 118.929"
            stroke="#6D6875"
            strokeWidth={2.56471}
            strokeLinecap="round"
          />
          <g id="neck">
            <path
              id="Vector 8"
              d="M48.8398 115.871V115.871C49.7307 115.858 49.9126 117.126 49.0536 117.362L48.1292 117.616C44.4734 118.621 40.6137 118.624 36.9544 117.625L35.9277 117.344C35.0381 117.101 35.2002 115.794 36.1219 115.777V115.777"
              stroke="#6D6875"
              strokeWidth={1.54696}
              strokeLinecap="round"
            />
            <path
              id="Vector 9"
              d="M48.8064 114.127V114.127C49.6974 114.114 49.8793 115.381 49.0203 115.617L48.0959 115.871C44.4401 116.877 40.5803 116.88 36.9211 115.88L35.8943 115.6C35.0048 115.357 35.1668 114.05 36.0886 114.033V114.033"
              stroke="#6D6875"
              strokeWidth={1.54696}
              strokeLinecap="round"
            />
            <path
              id="Vector 10"
              d="M48.0627 114.127L48.9871 113.873C49.8461 113.636 49.6642 112.369 48.7732 112.382L36.0554 112.288C35.1336 112.305 34.9716 113.612 35.8611 113.855L36.8879 114.136C40.5471 115.135 44.4069 115.132 48.0627 114.127Z"
              stroke="#6D6875"
              strokeWidth={1.54696}
              strokeLinecap="round"
            />
          </g>
        </>
      )}
      <path
        id="line"
        d="M40.9361 110.204V111.944H44.4168V110.204H40.9361ZM40.9361 33.4286V110.204H44.4168V33.4286H40.9361Z"
        stroke="#6D6875"
        strokeWidth={2.5}
      />
      <g id="top">
        <path
          id="Vector 3"
          d="M28.0324 33.4292V33.4292C28.0275 34.8975 25.9365 35.1623 25.5657 33.7416L25.2249 32.4357C23.6388 26.3578 23.7522 19.961 25.5529 13.9431L25.9907 12.4801C26.4259 11.0255 28.5706 11.3394 28.5706 12.8578V12.8578"
          stroke="#6D6875"
          strokeWidth={2.56471}
          strokeLinecap="round"
        />
        <path
          id="Vector 5"
          d="M31.8794 33.4292V33.4292C31.8746 34.8975 29.7835 35.1623 29.4128 33.7416L29.072 32.4357C27.4858 26.3578 27.5993 19.961 29.3999 13.9431L29.8377 12.4801C30.2729 11.0255 32.4176 11.3394 32.4176 12.8578V12.8578"
          stroke="#6D6875"
          strokeWidth={2.56471}
          strokeLinecap="round"
        />
        <path
          id="Vector 6"
          d="M35.7265 33.4292V33.4292C35.7217 34.8975 33.6306 35.1623 33.2599 33.7416L32.9191 32.4357C31.333 26.3578 31.4464 19.961 33.247 13.9431L33.6848 12.4801C34.12 11.0255 36.2647 11.3394 36.2647 12.8578V12.8578"
          stroke="#6D6875"
          strokeWidth={2.56471}
          strokeLinecap="round"
        />
      </g>
    </g>
  );
};

export default Rope;
